module.exports = __webpack_public_path__ + "img/item-middle.0f96cf29.jpg";